const orderStatus = (row) => {
  const map = {
    STATUS_IN: $t('trade.orderStatus1'),
    STATUS_DONE: $t('trade.orderStatus2'),
    CANCEL_DONE: $t('trade.orderStatus5'),
    EX_ORDER_STATUS_IN: $t('trade.orderStatus1'),
    EX_ORDER_STATUS_DONE: $t('trade.orderStatus2'),
    EX_ORDER_STATUS_CANCEL_ING: $t('trade.orderStatus3'),
    EX_ORDER_STATUS_CANCEL_FAILED: $t('trade.orderStatus4'),
    EX_ORDER_STATUS_CANCEL_DONE: $t('trade.orderStatus5'),
  }
  return map[row.orderStatus]
}

export default {
  orderStatus
}